var React = require('react');

function BaselineFastRewind24px (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M11 18V6l-8.5 6 8.5 6zm.5-6l8.5 6V6l-8.5 6z","key":0}),React.createElement("path",{"d":"M0 0h24v24H0z","fill":"none","key":1})]);
}

BaselineFastRewind24px.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = BaselineFastRewind24px;

BaselineFastRewind24px.default = BaselineFastRewind24px;
